<template>
	<k-editor-form v-if="channel">
		<template v-slot:left>
			<k-autocomplete
				:items="channelTypes"
				v-model="channel.type"
				label="Type"
				item-text="label"
				item-value="value">
			</k-autocomplete>

			<k-layout>
				<k-flex c6>
					<h6 v-if="!$is_admin()">{{channel.name}}</h6>
					<k-text-field v-if="$is_admin()" readonly v-model="channel.name" label="Stream name"></k-text-field>
				</k-flex>
				<k-flex c6>
					<k-text-field v-model="channel.title" label="Title"></k-text-field>
				</k-flex>
			</k-layout>


			<k-text-field textarea v-model="channel.meta.description" label="Description"></k-text-field>
			<k-text-field v-model="channel.meta.play_url" label="Play url" v-if="channel.type == 'output' && $is_admin()"></k-text-field>
			<k-text-field v-model="channel.meta.monitor_url" label="Monitor url" v-if="channel.type == 'output' && $is_admin()"></k-text-field>
			<k-text-field v-model="channel.meta.page_url" label="Page url" v-if="channel.type == 'output' && $is_admin()"></k-text-field>

			<billing-customer-select v-if="channel.type == 'output' && $is_admin()" v-model="channel.meta" customer_name="billing_customer" customer_label="Billing customer" contract_name="billing_contract" contract_label="Billing contract"></billing-customer-select>

			<channel-group-select :id="id" type="access" v-model="channel_groups" label="Access group" v-if="$is_admin()"></channel-group-select>

			<override-editor v-model="channel.meta.overrides" :channel="channel" v-if="$is_admin()"></override-editor>

			<k-autocomplete v-if="channel.type == 'output' && $is_admin()" label="Event form" :items="event_forms" v-model="channel.meta.event_form" item-text="name" item-value="name"></k-autocomplete>

			<div v-if="(channel.type == 'output' || channel.type == 'input') && $is_admin()">
				<k-checkbox label="Use transcoder" v-model="channel.transcoder" hide-details></k-checkbox>

				<div v-if="channel.transcoder == true">
					<template v-if="channel.type == 'output'">
						<k-checkbox label="Automatic transcoder"
						v-model="channel.meta.automatic_transcoder"
						hide-details
						></k-checkbox>

						<k-checkbox label="Use MediaConnect"
						v-model="channel.meta.use_mediaconnect"
						hide-details
						></k-checkbox>

						<div v-if="channel.meta.use_mediaconnect == true">
							<k-text-field v-model="channel.meta.mediaconnect_arns" label="MediaConnect arns (separated by ,)"></k-text-field>
						</div>
					</template>
					<k-layout>
						<k-flex c6>
							<k-autocomplete label="Transcoder size" :items="transcoderSizes" v-model="channel.meta.transcoder_size" item-text="name" item-value="value"></k-autocomplete>
						</k-flex>
						<k-flex c6>
							<k-autocomplete label="Transcoder config" :items="transcoder_configurations" v-model="channel.meta.transcoder_config" :item-text="transcoder_configuration_item_text" item-value="name">
							</k-autocomplete>
						</k-flex>
					</k-layout>

					<k-text-field v-model="channel.meta.transcoder_tag" label="Transcoder tag"></k-text-field>
				</div>
			</div>

			<div v-if="$is_admin()"> 
				<k-checkbox label="Use pull" v-model="channel.meta.use_pull" hide-details v-if="channel.type=='input'"></k-checkbox>
				<div v-if="channel.meta.use_pull">
					<k-text-field v-model="channel.meta.pull_url" label="Pull url"></k-text-field>
				</div>

				<template v-if="channel.type == 'output' && $is_admin()">
					<k-divider class="mt-3 mb-3" />
					<notifiers-editor v-model="channel.meta.notifiers" />
				</template>

				<k-checkbox label="System channel" v-model="channel.meta.system_channel" hide-details v-if="$is_admin()"></k-checkbox>
				<k-checkbox label="Is admin channel" v-model="channel.meta.is_admin_channel" hide-details v-if="$is_privilege('developer')"></k-checkbox>

			</div>

		</template>

		<template v-slot:right>
			<channel-group-select :id="id" type="template" v-model="channel_groups" label="Configuration presets" v-if="$is_admin()"></channel-group-select>
			<k-tabs @change="override_preview_select" v-model="override_preview_selected_tab">
						<k-tab label="Preview" name="preview" style="padding-top: 5px;">
							<json-editor v-model="preview_configuration" :readOnly="true" v-if="$is_admin()"></json-editor>
						</k-tab>
						<k-tab label="Overrides" name="overrides" :color="override_classes" style="padding-top: 5px;">
							<json-editor v-model="channel.configuration_overrides" v-if="$is_admin()"></json-editor>
						</k-tab>
			</k-tabs>
		</template>

		<template v-slot:left-buttons>
			<template v-if="channel">
				<template v-if="channel.type == 'input' && channel.transcoder == true">
					<template v-if="instance">
						<k-btn size="m" color="danger" @click="stop_streamer">Stop streamer</k-btn>
						<k-btn size="m" color="primary" @click="open_gui">Control</k-btn>
					</template>
					<template v-if="!instance">
						<k-btn size="m" color="primary" @click="start_streamer">Start streamer</k-btn>
					</template>
				</template>
				<template v-if="channel.meta.use_pull == true">
					<template v-if="!pull_status">
						<k-btn size="m" color="primary" @click="start_pull">Start pull</k-btn>
					</template>
					<template v-else>
						<k-btn size="m" color="danger" @click="stop_pull">Stop pull</k-btn>
					</template>
				</template>
			</template>
		</template>
		<template v-slot:right-buttons>
			<k-btn size="m" flat @click="reset">Reset</k-btn>
			<k-btn size="m" color="danger" v-show="is_edit && channel.state != 'archived'" @click="changeState('archived')">Archive</k-btn>
			<k-btn size="m" color="danger" v-show="is_edit && channel.state == 'archived'" @click="changeState('active')">Unarchive</k-btn>
			<k-btn size="m" color="success" @click="save(false)">Save</k-btn>
			<k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
		</template>
	</k-editor-form>
</template>


<script>
import Configuration from './Configuration'
import JsonEditor from '@/components/JsonEditor'
import NotifiersEditor from '@/components/NotifiersEditor'
import SettingsModel from '@/models/settings.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'
import OverrideEditor from './OverrideEditor'
import BillingCustomerSelect from '@/components/form_items/BillingCustomerSelect'
import ChannelGroupSelect from './ChannelGroupSelect'
import naturalSort from 'natural-sort'

export default {
	components: {
		Configuration,
		JsonEditor,
		NotifiersEditor,
		OverrideEditor,
		BillingCustomerSelect,
		ChannelGroupSelect
	},
	props: ["id"],
	data () {
		var ch = this.$cloudserver.channel("channels:"+(this.id||"create"));
    return {
			ws_channel: ch,
    	channel: this.convertChannel(ch.data),
  //  	channelTypes: ChannelModel.types(),
      transcoderSizes: ChannelModel.transcoder_sizes(),
      channel_groups: [],
      preview_configuration: {},
      natural_sort: naturalSort(),
      override_preview_selected_tab: "preview"
    }
  },
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.channel = this.convertChannel(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("channels:"+(this.id||"create"));
				this.ws_channel.join();
			}
		},
		channel_groups() {
			this.override_preview_select(0);
		}
	},
  created () {
  	this.ws_channel.join();
  },
  computed: {
    pull_status () {
      var status = ChannelModel.status(this.channel);
      if (typeof(status) == "undefined") return false;
      return true;
    },
  	instance () {
  		var ch = ChannelModel.get_channel(this.channel);
  		if (typeof(ch) != "undefined") {
	  		return ChannelModel.instance(this.channel);
	  	}
	  	return;
  	},
  	channelTypes () {
  		if (this.$is_admin() == true) return ChannelModel.types();
  		return [{label: "Input", value: "input"}];
  	},
		is_edit () {
			return typeof(this.channel) != "undefined" && this.channel.uuid != null;
		},
    transcoder_configurations () {
    	var list = SettingsModel.list("transcoder_configuration");
    	list.sort((a, b) => {
    		return this.natural_sort(a.title, b.title);
			});

      return list
    },
		event_forms () {
			return SettingsModel.list("event_form");
		},
		override_classes () {
			if(this.channel_groups.length > 0 && !_.isEmpty(this.channel.configuration_overrides)) return "danger";
			if(!_.isEmpty(this.channel.configuration_overrides)) return "";
			return []
		},
  },
  methods: {
  	start_pull () {
      ChannelModel.port_request(this.channel, "", function(msg) {
      }, function(msg) {
      	
      });
    },
    stop_pull () {
      ChannelModel.stop_channel(this.channel, "", function(msg) {
      }, function(msg) {
      });
    },

    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
  	override_preview_select(item) {
  		if(item == 0) {
  			if(this.$is_admin()) {
  				this.ws_channel.push("get_configuration", {configuration: this.channel.configuration_overrides, channel_groups: this.channel_groups})
  				.receive("ok", (msg) => {
  					this.preview_configuration = msg.data;
  				});
  			}
  		}
  	},
		changeState (state) {
      this.channel.state = state;
      this.save(false);
    },
    start_streamer () {
    	var self = this
    	if (this.channel.type == "input") {
        ChannelModel.start_transcoder(this.channel, (msg) => {
          self.$message.success("Streamer started!");
        }, (err) => {
          self.$message.success("Streamer start failed!" + JSON.stringify(msg));
        });
      }
    },
    stop_streamer () {
    	var self = this;
    	if (this.channel.type == "input") {
        var instance = ChannelModel.instance(this.channel);
    		InstanceModel.stop_transcoder(instance, (msg) => {
    			self.$message.success("Streamer stopped");
    		}, (err) => {
          self.$message.success("Streamer stop failed!" + JSON.stringify(err));
    		})
    	}
    },
    transcoder_configuration_item_text(config) {
    	if(_.isEmpty(config.title)) return config.name;
    	return config.title;
    },
		reset () {
			this.channel = this.convertChannel(this.ws_channel.data);
		},
  	save (close) {
			if(typeof(this.ws_channel) != "undefined") {
				var self = this;
				var channel = _.cloneDeep(this.channel);

				this.ws_channel.save({channel: channel, channel_groups: this.channel_groups})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Channel was created!");
						} else {
							self.$message.success("Channel was updated!");
						}
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.channel.uuid}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create channel!");
						} else {
							self.$message.warning("Unable to update channel!");
						}
					});
			}
  	},
		convertChannel (newVal, oldVal) {
			var channel = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(channel) == "undefined" || _.isEmpty(channel)) return undefined;
			if(_.isEmpty(channel.meta.notifiers)) channel.meta.notifiers = [];

			return channel;
		}
  }
}
</script>
